"use strict";

module.exports = function (
  departments,
  $uibModal,
  clients,
  $state,
  $translate,
  Client,
  dialog,
  gridConfiguration,
  Authentication
) {
  var _this = this;

  _this.selectedItems = [];
  const lstMyDeptsId=departments.map(dpt=>dpt.clientId)

  this.clients = clients;
  this.removeClients = function () {
    if (_this.selectedItems.length == 0) return;
    dialog
      .confirm({
        title: $translate.instant("DASHBOARD.CLIENTS.DIAGMULTIPLE.TITLE"),
        body:
          $translate.instant("DASHBOARD.CLIENTS.DIAGMULTIPLE.BODY") +
          " Sitios Seleccionados: " +
          _this.selectedItems.flatMap((clt) => clt.name).join(","),
        accept: $translate.instant("DASHBOARD.DELETE"),
        cancel: $translate.instant("DASHBOARD.CANCEL"),
        size: "sm",
      })
      .then(function () {
        for (let i = 0; i < _this.selectedItems.length; i++) {
          if (
            (_this.selectedItems[i].isOU &&
              Authentication.isAuthorized(["admin"])) ||
            _this.selectedItems[i].isOU != true
          )
            Client.removeById({
              id: _this.selectedItems[i].id,
            })
              .$promise.then(function () {
                $state.reload("dashboard.clients");
              })
              .catch(function (error) {
                console.log(error);
              });
        }
      });
  };

  this.editClient = function (client) {
    $uibModal
      .open({
        animation: true,
        controller: [
          "$uibModalInstance",
          "$http",
          "Client",
          "Authentication",
          "client",
          "clients",
          function (
            $uibModalInstance,
            $http,
            Client,
            Authentication,
            client,
            clients
          ) {
            var _this = this;
            if (client != undefined) _this.client = angular.copy(client);
            else _this.client = { owners: [] };
            this.Authentication = Authentication;
            _this.clients = clients.filter((clt) => clt.isOU && ( Authentication.isAuthorized(['admin']) || clt.owners.find((owner) => owner.id == Authentication.currentUser())));
            this.getLocation = function (val) {
              return $http
                .get("//maps.googleapis.com/maps/api/geocode/json", {
                  params: {
                    address: val,
                    sensor: false,
                  },
                })
                .then(function (response) {
                  return response.data.results.map(function (item) {
                    // console.log("item");
                    return item.formatted_address;
                  });
                })
                .catch(function (error) {
                  console.log(error);
                });
            };

            this.saveClient = function () {
              delete _this.client.tenantId; //for some reason i need this to update client correctly
              delete _this.client.isSelected;
              _this.owners =
                _this.client.isOU == true
                  ? _this.client.owners.map((o) => o.id)
                  : [];
              _this.loading = true;
              return Client.upsert(_this.client)
                .$promise.then(function (data) {
                  Client.addOwner(
                    { clientId: data.id },
                    _this.owners
                  ).$promise.then(function (data) {
                    $uibModalInstance.close();
                  });
                })
                .catch(function (error) {
                  console.log(error);
                  _this.loading = false;
                });
            };
          },
        ],
        templateUrl: "dashboard-clients/dashboardNewClientModal.html",
        controllerAs: "modal",
        size: "md",
        windowClass: "dialog",
        bindToController: true,
        resolve: {
          client: function () {
            return client;
          },
          clients: function () {
            return _this.clients;
          },
        },
      })
      .result.then(function () {
        $state.reload("dashboard.clients");
      });
  };

  function fullNameGetter(params) {
    if (params.data.parent) {
      return params.data.parent.name.concat("-", params.data.name);
    }
    return params.data.name;
  }
  this.selectAllStatus = false;
  this.selectAll = function (status) {
    if (status) {
      _this.gridOptions.api.forEachNodeAfterFilterAndSort(function (node) {
        _this.gridOptions.api.selectNode(node, true);
      });
      return;
    }
    _this.gridOptions.api.deselectAll();

    return;
  };
  _this.columnDefs = [
    {
      headerCellRenderer: gridConfiguration.selectAllRenderer,
      field: "",
      checkboxSelection: true,
      width: 50,
      suppressMenu: true,
      suppressSorting: true,
      pinned: "left",
      suppressResize: true,
    },
    {
      headerName: "U.O.",
      field: "isOU",
      width: 70,
      colId: "isOU",
      pinned: "left",
      cellRenderer: gridConfiguration.checkboxRenderer,
      filter: "set",
      filterParams: { values: [true, false] },
    },
    {
      headerName: $translate.instant("DASHBOARD.CLIENTS.COLS.ASSOCIATED"),
      field: "parent.name",
      width: 150,
      colId: "parentName",
      pinned: "left",
    },
    {
        headerName: $translate.instant("DASHBOARD.CLIENTS.COLS.IMPORTED_ACRONYM"),
        field: "fromImport",
        width: 70,
        colId: "fromImport",
        pinned: "left",
        cellRenderer: gridConfiguration.checkboxRenderer,
        filter: "set",
        filterParams: { values: [true, false] },
    },
    {
      headerName: $translate.instant("DASHBOARD.CLIENTS.COLS.NAME"),
      field: "name",
      colId: "name",
      pinned: "left",
    },
    {
      headerName: $translate.instant("DASHBOARD.CLIENTS.COLS.DETAIL"),
      field: "details",
      colId: "details",
    },
    {
      headerName: $translate.instant("DASHBOARD.CLIENTS.COLS.EMAIL"),
      field: "email",
      colId: "email",
    },
    {
      headerName: $translate.instant("DASHBOARD.CLIENTS.COLS.PHONE"),
      field: "phone",
      colId: "phone",
    },
    {
      headerName: "FullName",
      field: "isOU",
      valueGetter: fullNameGetter,
      sort: "asc",
      initialSortIndex: 1,
    },
  ];

  _this.gridOptions = {
    debug: false,
    rowBuffer: 0,
    columnDefs: _this.columnDefs,
    enableFilter: true,
    enableColResize: true,
    enableSorting: true,
    rowData: _this.clients.filter((clt) => {
      if ( Authentication.isAuthorized(['admin']) ||
        (clt.isOU &&
        clt.owners.find((owner) => owner.id == Authentication.currentUser()))
      )
        return true;
      if(lstMyDeptsId.includes(clt.clientId) )
        return true;
    }),
    rowSelection: "multiple",
    rowHeight: 40,
    headerHeight: 40,
    angularCompileRows: true,
    angularCompileFilters: true,
    angularCompileHeaders: true,
    localeText: gridConfiguration.localeText,
    onSelectionChanged: function (selection) {
      _this.selectedItems = selection.selectedRows;
    },
    onRowDoubleClicked: function (row) {
      _this.editClient(row.data);
    },
  };
};
